<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>    
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:new="createHandler"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
         v-on:cancel="cancelHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import TrainingRecordForm from "../../../components/training/trainingrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": TrainingRecordForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('trainingrecord.edittrainingrecord'),
      pageTitleValue: "",
      formData: [],

      // chargeItems: [],
      // chargeList: [],
      // chargecodes: [],
 
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadTrainingRecordHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/trainingrecord/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          // vm.formData.materialdoc = res.data.rec[0].materialdoc;
          // vm.formData.materialdocname = res.data.rec[0].materialdocname;

          // vm.formData.certificatedoc = res.data.rec[0].certificatedoc;
          // vm.formData.certificatedocname = res.data.rec[0].certificatedocname;

          vm.formData.staffcode = res.data.rec[0].staffno;

           if (res.data.rec[0].startdate) {
            vm.formData.startdate = moment(res.data.rec[0].startdate).format(
              "YYYY-MM-DD"
            );
          }

            if (res.data.rec[0].enddate) {
            vm.formData.enddate = moment(res.data.rec[0].enddate).format(
              "YYYY-MM-DD"
            );
          }

              console.log(res.data.rec[0].enddate)

          
            if (res.data.rec[0].recertification) {
            vm.formData.recertification = moment(res.data.rec[0].recertification).format(
              "YYYY-MM-DD"
            );
          }

          console.log(res.data.rec[0].recertification)

            if (res.data.rec[0].hrdfclaimeddate) {
            vm.formData.hrdfclaimeddate = moment(res.data.rec[0].hrdfclaimeddate).format(
              "YYYY-MM-DD"
            );
          }

            if (res.data.rec[0].hrdfapproveddate) {
            vm.formData.hrdfapproveddate = moment(res.data.rec[0].hrdfapproveddate).format(
              "YYYY-MM-DD"
            );
          }


           if (
            res.data.rec[0].Iselearning == "N" ||
            res.data.rec[0].Iselearning == null
          ) {
            vm.formData.Iselearning = false;
          } else {
            vm.formData.Iselearning = true;
          }
          

       //   vm.formData.grpvalueid = res.data.rec[0].grpvalueid;
          
          vm.formData.stamp = res.data.rec[0].stamp;
        //  vm.formData.lockstaff = res.data.rec[0].lockstaff;

          vm.formData.userid = this.$store.getters.userId;
          vm.pageTitleValue = res.data.rec[0].valuedesc;

           this.loadTrainingExpenseHandler();

       //  vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadTrainingExpenseHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/trainingrecorddetail/" + this.id})
        .then((res) => {
          vm.formData.trainingrecorddetail = res.data.rec;
         
        // for (let i = 0; i < res.data.rec.length; i++) {
        //     if (res.data.rec[i].receiptdate) {
        //       vm.formData.trainingrecorddetail[i].receiptdate = moment(
        //         res.data.rec[i].receiptdate
        //       ).format("YYYY-MM-DD");
        //     }
        //   }
          

          for (let i = 0; i < vm.formData.trainingrecorddetail.length; i++) {
            Object.assign(vm.formData.trainingrecorddetail[i], {
              action: 2,
            });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/trainingrecord/" + vm.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "trainingrecordlist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "trainingrecordlist" });
    },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      this.$store.dispatch('delete', {url:
            "/trainingrecord/" +
            vm.id +
            "/" +
            this.formData.userid}
        )
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "trainingrecordlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "trainingrecordnew" });
    },
  },

  async mounted() {
    await this.loadTrainingRecordHandler();
  
  },
};
</script>